import { TThunkAction } from '../../types/redux/thunk';
import { getDistrictFlatStats } from '../../utils/district/getDistrictFlatStats';
import { setFieldsState } from '../fieldsState';

export function setFlatStats(): TThunkAction {
  return async (dispatch, getState, context) => {
    const { logger, config } = context;
    const {
      fieldsState: { district, flatPrice, flatPriceChanged, rooms },
      flatStats,
    } = getState();

    const isGeoSuggestEnabled = config.get<boolean>('investment-calculator-frontend.geoSuggest.enabled');
    if (isGeoSuggestEnabled) {
      if (!flatStats.result) {
        return;
      }

      const currentFlatStats = flatStats.result[rooms];
      const nextFlatPrice = !flatPriceChanged ? currentFlatStats.avgPrice : flatPrice;
      dispatch(
        setFieldsState({
          flatPrice: nextFlatPrice,
          flatPriceInc: currentFlatStats.avgIncrease,
        }),
      );

      return;
    }

    if (!district) {
      return;
    }

    const flatStatsStatic = getDistrictFlatStats(district, rooms);
    if (!flatStatsStatic) {
      // TODO custom error
      logger.error(
        new Error(`[setFlatStats] Invalid rooms or district selected: rooms = "${rooms}", district = "${district}"`),
      );

      return;
    }

    const nextFlatPrice = !flatPriceChanged ? flatStatsStatic.price : flatPrice;
    dispatch(
      setFieldsState({
        flatPrice: nextFlatPrice,
        flatPriceInc: flatStatsStatic.percent,
      }),
    );
  };
}
